<template>
  <customer-workshop-selection ></customer-workshop-selection>
</template>

<script>
import CustomerWorkshopSelection from "@/components/customerWorkshopSelection.vue";
export default {
  name: "chartView",
  components: {CustomerWorkshopSelection },
  data() {
    return {
      workshopId: ''
    }
  },
  computed: {
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style scoped>

</style>